import { render, staticRenderFns } from "./FamilyLand.vue?vue&type=template&id=4afc4dc5&scoped=true&"
import script from "./FamilyLand.vue?vue&type=script&lang=js&"
export * from "./FamilyLand.vue?vue&type=script&lang=js&"
import style0 from "./FamilyLand.vue?vue&type=style&index=0&id=4afc4dc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afc4dc5",
  null
  
)

export default component.exports